import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatTabsModule} from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';



@NgModule({
    imports: [
        MatButtonModule,
        MatInputModule,
        MatCardModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatTableModule,
        MatTooltipModule,
        MatExpansionModule,
        MatSelectModule,
        MatMenuModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatChipsModule,
        FormsModule,
        MatGridListModule,
        MatTabsModule,
        MatProgressBarModule,
        MatBadgeModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    exports: [
        MatButtonModule,
        MatInputModule, 
        MatCardModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatProgressSpinnerModule ,
        MatToolbarModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatTableModule,
        MatTooltipModule,
        MatExpansionModule,
        MatSelectModule,
        MatMenuModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatChipsModule,
        FormsModule,
        MatGridListModule,
        MatTabsModule,
        MatProgressBarModule,
        MatBadgeModule,
        MatDatepickerModule,
        MatNativeDateModule
    ]
})
export class MaterialModule { }
